import { Component, Input } from '@angular/core';
import { UICallHistoryItem } from '../../../models/company-call-history/company-call-history.model';
import { UtilsService } from '../../../services';

@Component({
  selector: 'call-recording',
  templateUrl: './call-recording.component.html',
  styleUrls: ['./call-recording.component.scss']
})
export class CallRecordingComponent {
  @Input() callItem: UICallHistoryItem;

  constructor(
    private utilsService: UtilsService
  ) {}

  public openLink(link: string) {
    this.utilsService.openExternalLink(link);
  }
}
